module.exports = __webpack_public_path__ + "img/lazy.78f3d6e8.gif";